module.exports = __webpack_public_path__ + "static/media/500.5e6bf3ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/500.svg
// module id = 1347
// module chunks = 0